import { HttpParams } from '@angular/common/http';
import { AfterViewChecked, Component, Input, OnInit } from '@angular/core';
import { DynamicImageSet } from 'src/app/model/dynamic-image-set';
import { EnvConfigurationService } from 'src/app/services/config/env-configuration.service';
import { ChangeDetectorRef } from '@angular/core';
import { TestArea } from '../test-area';

@Component({
  selector: 'app-image-component',
  templateUrl: 'image.component.html',
  styleUrls: ['image.component.scss'],
})
export class ImageComponent implements OnInit, AfterViewChecked {

  @Input() angle: string;
  @Input() image: any;
  @Input() dynamicImageSet: DynamicImageSet;
  @Input() selectedOptions: string[];
  @Input() testArea: TestArea;
  @Input() containerWidth: any;

  constructor(private cdRef: ChangeDetectorRef) {
  }

  ngAfterViewChecked(): void {
    this.cdRef.detectChanges();
  }

  ngOnInit(): void {
  }

  getUrl(): string {
    const baseUrl = EnvConfigurationService.getDynamicTestUrl(this.testArea);
    if (this.selectedOptions.some(o => o.startsWith('0M') || o.startsWith('0P'))) {
      let parameters = new HttpParams();
      parameters = parameters
        .append('versionId', this.dynamicImageSet.version)
        .append('viewport', this.dynamicImageSet.viewport.substring(0, 3))
        .append('driverType', this.dynamicImageSet.model)
        .append('size', this.dynamicImageSet.resolution)
        .append('view', this.angle)
        .append('color', this.selectedOptions.find(o => o.startsWith('0M')))
        .append('trim', this.selectedOptions.find(o => o.startsWith('0P')))
        .append('options', String(this.selectedOptions.filter(o => !(o.startsWith('0M') || o.startsWith('0P')))));
      return `${baseUrl}/api/v2/image/debug/dis/${this.dynamicImageSet.id}/imageFromOptions?` + parameters.toString();
    } else {
      let parameters = new HttpParams();
      parameters = parameters
        .append('viewport', this.dynamicImageSet.viewport.substring(0, 3))
        .append('driverType', this.dynamicImageSet.model)
        .append('size', this.dynamicImageSet.resolution)
        .append('view', this.angle)
        .append('layers', String(this.selectedOptions));
      return `${baseUrl}/api/v2/image/dis/${this.dynamicImageSet.id}/image?` + parameters.toString();
    }
  }

}
